const CaseIdentityCardDefault = () =>
  import("@/components/atm-front/cases/case/CaseIdentityCard/CaseIdentityCardDefault.vue");
const CaseIdentityCardRelation = () =>
  import("@/components/atm-front/cases/case/CaseIdentityCard/CaseIdentityCardRelation.vue");
const CaseIdentityCardMission = () =>
  import("@/components/atm-front/cases/case/CaseIdentityCard/CaseIdentityCardMission.vue");

export default [
  {
    path: "",
    name: "CaseIdentityCardDefault",
    component: CaseIdentityCardDefault,
  },
  {
    path: "relation",
    name: "CaseIdentityCardRelation",
    component: CaseIdentityCardRelation,
  },
  {
    path: "mission",
    name: "CaseIdentityCardMission",
    component: CaseIdentityCardMission,
  },
];
